import React, { useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import { makeStyles } from "tss-react/mui";
import { Box } from "@mui/material";

import { FilterStaticSelect, SelectorOption } from "../interfaces";
import { generateOptions } from "../modalInputs/StaticSelector";
import { CustomAutocomplete } from "../../components/Inputs/CustomAutocomplete";

const useStyles = makeStyles()(() => ({
  // Only the field's width: fill and outline come from the wrapper and the theme.
  field: {
    flex: "0 1 224px",
  },
}));

/**
 * Generate Static filter
 *
 * Used to filter table with static values
 */
const StaticSelectorFilter = ({
  filter,
  filterValue,
  onChange,
}: {
  filter: FilterStaticSelect;
  filterValue: string | null;
  onChange: (newValue: any) => void;
}) => {
  const intl = useIntl();
  const { classes: basicsClasses } = useStyles();
  const options = useMemo(() => generateOptions(filter.key), [filter.key]);
  const [newValue, setNewValue] = useState<SelectorOption | null>(
    options.find((opt) => opt.key === filterValue) ?? null
  );

  // Reset filter on reset button filter click
  useEffect(() => {
    if (filterValue === null) {
      setNewValue(null);
    }
  }, [filterValue]);

  return (
    <Box className={basicsClasses.field}>
      <CustomAutocomplete
        filterOptions={(options) => options}
        formStyle={false}
        fullWidth
        getOptionLabel={(option) => {
          return intl.formatMessage({ id: option.label }) || "";
        }}
        isOptionEqualToValue={(option, value) => {
          return option.key === value?.key;
        }}
        options={options}
        onChange={(_, value) => {
          setNewValue(value);
          onChange(value ? value.key : null);
        }}
        onClick={(e) => {
          /* This one is to avoid the table re-rendering on the focus loss */
          e.stopPropagation();
        }}
        placeholder={intl.formatMessage({ id: filter.label })}
        variant="standard"
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.key}>
              {intl.formatMessage({ id: option.label })}
            </li>
          );
        }}
        size="small"
        value={newValue || null}
      />
    </Box>
  );
};

export default StaticSelectorFilter;
